export enum ButtonStyle {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    PRIMARY_MODAL = "primary button-modal",
    LIGHT = "light",
}
